module.exports = __webpack_public_path__ + "static/media/placeholderImage.8a3842e5.jpeg";